import { Record } from "../../../../fable_modules/fable-library.3.7.9/Types.js";
import { ExternalTool, SharedCorpusInfo__HasAttribute_Z721C83C5, StringUtils_replace, AudioType, MediaPlayerType, AudioType$reflection } from "../../../../Shared/Shared.js";
import { record_type, array_type, class_type, string_type, bool_type, option_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";
import { createElement } from "react";
import { safeHash, stringHash, numberHash, equals, int32ToString, createObj } from "../../../../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_combineClasses } from "../../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { indexed as indexed_1, item, head, collect, length, tryFindIndex as tryFindIndex_1, contains, map as map_1, ofArray, singleton, empty } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { Interop_reactApi } from "../../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { LoadedCorpus_ShowingResults_Concordance_Msg } from "../../../Update.js";
import { skip, concat, map2, getSubArray, indexed, tryFindIndex, mapIndexed, choose, map } from "../../../../fable_modules/fable-library.3.7.9/Array.js";
import { FSharpMap__get_Item, FSharpMap__TryFind, toArray, toList } from "../../../../fable_modules/fable-library.3.7.9/Map.js";
import { toArray as toArray_2, map as map_3, empty as empty_1, append, iterate, singleton as singleton_1, delay, toList as toList_1 } from "../../../../fable_modules/fable-library.3.7.9/Seq.js";
import { Jplayer as Jplayer_1 } from "../../../../../jplayer.js";
import { WFplayer as WFplayer_1 } from "../../../../../wfplayer.js";
import { useReact_useEffectOnce_3A5B6456, useReact_useElementRef } from "../../../../fable_modules/Feliz.1.64.0/React.fs.js";
import { value as value_155, map as map_2, toArray as toArray_1 } from "../../../../fable_modules/fable-library.3.7.9/Option.js";
import { createPortal } from "react-dom";
import { fromTicks } from "../../../../fable_modules/fable-library.3.7.9/TimeSpan.js";
import { fromBits } from "../../../../fable_modules/fable-library.3.7.9/Long.js";
import { split, isNullOrWhiteSpace, join } from "../../../../fable_modules/fable-library.3.7.9/String.js";
import { isMatch as isMatch_1, replace, match } from "../../../../fable_modules/fable-library.3.7.9/RegExp.js";
import { SyntaxNode, Corpus__get_SharedInfo } from "../../../Model/Model.js";
import { List_except } from "../../../../fable_modules/fable-library.3.7.9/Seq2.js";
import { rangeDouble } from "../../../../fable_modules/fable-library.3.7.9/Range.js";
import { separatorRow, textColumns, idColumn, ResultLineFields } from "./Common.js";
import { FSharpSet__Contains } from "../../../../fable_modules/fable-library.3.7.9/Set.js";
import { parse } from "../../../../fable_modules/fable-library.3.7.9/Int32.js";
import syntax_tree from "../../../../../syntax_tree.jsx";

export class SearchResultInfo extends Record {
    constructor(AudioType, HasVideo, SId, MessageId, PreMatch, Match, PostMatch, FullText) {
        super();
        this.AudioType = AudioType;
        this.HasVideo = HasVideo;
        this.SId = SId;
        this.MessageId = MessageId;
        this.PreMatch = PreMatch;
        this.Match = Match;
        this.PostMatch = PostMatch;
        this.FullText = FullText;
    }
}

export function SearchResultInfo$reflection() {
    return record_type("View.LoadedCorpus.ResultViews.Cwb.Spoken.SearchResultInfo", [], SearchResultInfo, () => [["AudioType", option_type(AudioType$reflection())], ["HasVideo", bool_type], ["SId", string_type], ["MessageId", string_type], ["PreMatch", array_type(class_type("Fable.React.ReactElement"))], ["Match", array_type(class_type("Fable.React.ReactElement"))], ["PostMatch", array_type(class_type("Fable.React.ReactElement"))], ["FullText", option_type(string_type)]]);
}

export function WFplayer(wFplayerInputProps) {
    return null;
}

export function Jplayer(jplayerInputProps) {
    return null;
}

export function MediaPlayerPopup(mediaPlayerPopupInputProps) {
    let elems_3, elms, elms_1, children_1, props_3, elems_7, elms_3, children_5, props_12, properties_16;
    const dispatch = mediaPlayerPopupInputProps.dispatch;
    const mediaPlayerInfo = mediaPlayerPopupInputProps.mediaPlayerInfo;
    let header;
    const props_7 = ofArray([["style", {
        padding: 20,
        marginBottom: 0,
    }], (elems_3 = [(elms = singleton(createElement("div", createObj(Helpers_combineClasses("level-item", empty())))), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), (elms_1 = singleton((children_1 = singleton((props_3 = ofArray([["title", "Close"], ["children", "Close"], ["className", "is-info"], ["style", {
        marginLeft: 40,
    }], ["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(11));
    }]]), createElement("button", createObj(Helpers_combineClasses("button", props_3))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    }))), createElement("div", {
        className: "level-right",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]);
    header = createElement("nav", createObj(Helpers_combineClasses("level", props_7)));
    let mediaDisplay;
    const divs = createObj(map((tupledArg) => {
        const value_26 = tupledArg[1];
        const valueObj = {
            Speaker: value_26.Speaker,
            Line: createObj(map((tupledArg_1) => {
                const attrObj = createObj(map_1((tupledArg_2) => [tupledArg_2[0], tupledArg_2[1]], toList(tupledArg_1[1])));
                return [int32ToString(tupledArg_1[0]), attrObj];
            }, value_26.Line)),
            From: value_26.From,
            To: value_26.To,
            IsMatch: value_26.IsMatch,
        };
        return [int32ToString(tupledArg[0]), valueObj];
    }, toArray(mediaPlayerInfo.MediaObject.Divs)));
    const elms_2 = toList_1(delay(() => {
        const matchValue = mediaPlayerInfo.Type;
        switch (matchValue.tag) {
            case 0: {
                return singleton_1(createElement(Jplayer_1, {
                    mediaObj: mediaPlayerInfo.MediaObject,
                    divs: divs,
                    mediaType: "audio",
                    hasLocalMedia: false,
                    hasAudio: true,
                }));
            }
            case 1: {
                return singleton_1(createElement(Jplayer_1, {
                    mediaObj: mediaPlayerInfo.MediaObject,
                    divs: divs,
                    mediaType: "video",
                    hasLocalMedia: false,
                    hasAudio: true,
                }));
            }
            default: {
                return singleton_1(createElement(WFplayer_1, {
                    mediaObj: mediaPlayerInfo.MediaObject,
                    divs: divs,
                }));
            }
        }
    }));
    mediaDisplay = createElement("section", {
        className: "section",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    });
    let footer;
    const props_16 = ofArray([["style", {
        padding: 20,
        marginBottom: 0,
    }], (elems_7 = [createElement("div", createObj(Helpers_combineClasses("level-left", empty()))), (elms_3 = singleton((children_5 = singleton((props_12 = ofArray([["title", "Close"], ["children", "Close"], ["className", "is-info"], ["style", {
        marginLeft: 40,
    }], ["onClick", (_arg2) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(11));
    }]]), createElement("button", createObj(Helpers_combineClasses("button", props_12))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_5)),
    }))), createElement("div", {
        className: "level-right",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])]);
    footer = createElement("nav", createObj(Helpers_combineClasses("level", props_16)));
    const elementRef = useReact_useElementRef();
    useReact_useEffectOnce_3A5B6456(() => {
        iterate((popupElement) => {
            popupElement.focus();
        }, toArray_1(elementRef.current));
    });
    return createPortal(createElement("div", createObj(ofArray([["className", "overscroll-contain"], (properties_16 = ofArray([["height", 100 + "%"], ["top", 0], ["left", 0], ["width", 100 + "%"], ["position", "absolute"], ["zIndex", 40], ["backgroundColor", "white"], ["overflowX", "hidden"], ["border", (((1 + "px ") + "solid") + " ") + "black"], ["transitionProperty", "height"], ["transitionDuration", fromTicks(fromBits(3500000, 0, false)) + "ms"], ["transitionTimingFunction", "ease-out"]]), ["style", createObj(properties_16)]), ["ref", elementRef], ["tabIndex", 0], ["onKeyUp", (e) => {
        if (e.key === "Escape") {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(11));
        }
    }], ["onClick", (e_1) => {
        e_1.stopPropagation();
    }], ["children", Interop_reactApi.Children.toArray([header, mediaDisplay, footer])]]))), document.getElementById("media-player-popup-root"));
}

export function concordanceTable(model, corpus, pageResults, loadedCorpusDispatch, dispatch) {
    let attrs_2, props_38, elems_15;
    let mediaPlayer;
    const matchValue = model.MediaPlayer;
    if (matchValue == null) {
        mediaPlayer = null;
    }
    else {
        const mediaPlayerInfo = matchValue;
        mediaPlayer = createElement(MediaPlayerPopup, {
            mediaPlayerInfo: mediaPlayerInfo,
            dispatch: dispatch,
        });
    }
    const audioVideoLinks = (resultInfo, rowIndex) => {
        let elems_5;
        const audioButton = (title, icon) => {
            let elems_1, elms;
            const props_2 = ofArray([["className", "is-small"], ["title", title], ["style", {
                marginLeft: 2,
                marginTop: 2,
                marginBottom: 2,
            }], ["onClick", (_arg1) => {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(9, new MediaPlayerType(0), rowIndex));
            }], (elems_1 = [(elms = singleton(createElement("i", {
                className: join(" ", ["fa", icon]),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]);
            return createElement("button", createObj(Helpers_combineClasses("button", props_2)));
        };
        return createElement("span", createObj(ofArray([["style", {
            whiteSpace: "nowrap",
        }], (elems_5 = toList_1(delay(() => {
            let props_6, elems_3, elms_1;
            return append(resultInfo.HasVideo ? singleton_1((props_6 = ofArray([["className", "is-small"], ["title", "Show video"], ["style", {
                marginTop: 2,
                marginBottom: 2,
            }], ["onClick", (_arg2) => {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(9, new MediaPlayerType(1), rowIndex));
            }], (elems_3 = [(elms_1 = singleton(createElement("i", {
                className: join(" ", ["fa fa-film"]),
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("button", createObj(Helpers_combineClasses("button", props_6))))) : empty_1(), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = resultInfo.AudioType, (matchValue_1 == null) ? singleton_1(null) : ((matchValue_1.tag === 1) ? singleton_1(audioButton("Show more context", "fa-search")) : singleton_1(audioButton("Play audio", "fa-volume-up")))), delay(() => {
                    let props_9, elems_4;
                    return equals(resultInfo.AudioType, new AudioType(0)) ? singleton_1((props_9 = ofArray([["className", "is-small"], ["title", "Show waveform"], ["style", {
                        marginLeft: 2,
                        marginTop: 2,
                        marginBottom: 2,
                        paddingLeft: 6,
                        paddingRight: 6,
                    }], ["onClick", (_arg3) => {
                        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(9, new MediaPlayerType(2), rowIndex));
                    }], (elems_4 = [createElement("img", {
                        src: "speech/waveform.png",
                        style: {
                            width: 12,
                        },
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]), createElement("button", createObj(Helpers_combineClasses("button", props_9))))) : empty_1();
                }));
            }));
        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])));
    };
    const processField = (displayedFieldIndex_1, maybeOrtPhonIndex, maybeLemmaIndex_1, tipFieldIndexes_1, field) => choose((tupledArg_3) => {
        let maybeLemmaIndex, token, attrs, maybeUrlsIndex, tipText, a_1, array_5, array_4, array_3, maybeUrls, urlsIndex_1, array_7, dt, displayedText, links, elems_12;
        const index_5 = tupledArg_3[0] | 0;
        const token_1 = tupledArg_3[1];
        const m_2 = match(/<who_name_(.+?)>/g, token_1);
        if (m_2 != null) {
            const speakerId = m_2[1] || "";
            return [createElement("span", {
                key: index_5,
                className: "speaker-id",
                children: `<${speakerId}> `,
            }), ""];
        }
        else if (!(token_1.indexOf("\u003c/who_name\u003e") >= 0)) {
            return (maybeLemmaIndex = maybeLemmaIndex_1, (token = token_1, isNullOrWhiteSpace(token) ? [null, ""] : ((attrs = mapIndexed((index_2, attr) => {
                const a = attr;
                let pattern_matching_result;
                if (maybeLemmaIndex != null) {
                    if (maybeLemmaIndex === index_2) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return `"${a}"`;
                    }
                    case 1: {
                        return a;
                    }
                }
            }, split(token, ["/"], null, 0)), (maybeUrlsIndex = tryFindIndex((attr_1) => (attr_1.indexOf("\\$https?:") >= 0), attrs), (tipText = join(" ", map((tuple) => tuple[1], (a_1 = ((array_5 = ((array_4 = ((array_3 = indexed(attrs), array_3.filter((tupledArg) => contains(tupledArg[0], tipFieldIndexes_1, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: numberHash,
            })))), array_4.filter((tupledArg_1) => {
                if (maybeUrlsIndex == null) {
                    return true;
                }
                else {
                    return tupledArg_1[0] !== maybeUrlsIndex;
                }
            }))), array_5.filter((tupledArg_2) => (!contains(tupledArg_2[1], ofArray(["__UNDEF__", "\"__UNDEF__\"", "\u003ci\u003e__UNDEF__\u003c/i\u003e", "-", "_", "\"_\"", "\u003ci\u003e_\u003c/i\u003e"]), {
                Equals: (x_2, y_2) => (x_2 === y_2),
                GetHashCode: stringHash,
            }))))), Corpus__get_SharedInfo(corpus).IsTreebank ? getSubArray(a_1, 0, a_1.length - 2) : a_1))), (maybeUrls = ((maybeUrlsIndex == null) ? (void 0) : ((urlsIndex_1 = (maybeUrlsIndex | 0), (array_7 = split(StringUtils_replace("!!", "/", attrs[urlsIndex_1]), ["$"], null, 0), array_7.filter((arg) => (!isNullOrWhiteSpace(arg))))))), (dt = StringUtils_replace("__UNDEF__", "", attrs[displayedFieldIndex_1]), (displayedText = ((maybeUrls == null) ? dt : ((links = map2((url, symbol) => createElement("a", {
                key: url,
                href: url,
                target: "_blank",
                dangerouslySetInnerHTML: {
                    __html: symbol,
                },
            }), maybeUrls, ["[1]", "[2]"]), createElement("span", createObj(ofArray([["style", {
                whiteSpace: "nowrap",
            }], (elems_12 = [createElement("span", {
                children: [dt],
            }), createElement("sup", {
                children: Interop_reactApi.Children.toArray(Array.from(links)),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])])))))), [createElement("span", createObj(toList_1(delay(() => append(singleton_1(["key", `${index_5}${tipText}`]), delay(() => append(singleton_1(["data-tooltip", tipText]), delay(() => append(singleton_1(["className", "has-tooltip-arrow"]), delay(() => {
                let matchValue_3, fontFamily;
                return append((matchValue_3 = Corpus__get_SharedInfo(corpus).FontFamily, (matchValue_3 == null) ? ((empty_1())) : ((fontFamily = matchValue_3, singleton_1(["style", {
                    fontFamily: fontFamily,
                }])))), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([displayedText, " "])])));
            })))))))))), dt])))))))));
        }
        else {
            return void 0;
        }
    }, indexed(split(StringUtils_replace("\\s*\u003c/who_name\u003e", " $\u0026", StringUtils_replace("\u003cwho_name\\s+(.+?)\u003e\\s*", "\u003cwho_name_$1\u003e ", field)), [])));
    let attributes;
    const matchValue_4 = Corpus__get_SharedInfo(corpus).LanguageConfig;
    if (matchValue_4.tag === 1) {
        throw (new Error("NOT IMPLEMENTED!"));
    }
    else {
        attributes = ((matchValue_4.fields[0] == null) ? empty() : ((attrs_2 = matchValue_4.fields[0], attrs_2)));
    }
    const ortIndex_1 = 0;
    const maybePhonIndex_1 = map_2((i) => (i + 1), tryFindIndex_1((attr_3) => (attr_3.Code === "phon"), attributes));
    const maybeLemmaIndex_3 = map_2((i_1) => (i_1 + 1), tryFindIndex_1((attr_4) => (attr_4.Code === "lemma"), attributes));
    const maybeOrigIndex_1 = map_2((i_2) => (i_2 + 1), tryFindIndex_1((attr_5) => (attr_5.Code === "orig"), attributes));
    const ortTipIndexes_1 = List_except([ortIndex_1], toList_1(rangeDouble(0, 1, length(attributes))), {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: numberHash,
    });
    const phonTipIndexes_1 = (maybePhonIndex_1 == null) ? toList_1(rangeDouble(0, 1, length(attributes))) : List_except([maybePhonIndex_1], toList_1(rangeDouble(0, 1, length(attributes))), {
        Equals: (x_4, y_4) => (x_4 === y_4),
        GetHashCode: numberHash,
    });
    const rows = (pageResults == null) ? empty() : collect((tupledArg_4) => {
        let m_1, elems_7, rowIndex_3, resultInfo_2, resultLineFields_1, elems_10, resultLineFields_2, elems_11;
        const rowIndex_5 = tupledArg_4[0] | 0;
        const searchResult_1 = tupledArg_4[1];
        const phonTipIndexes = phonTipIndexes_1;
        const ortTipIndexes = ortTipIndexes_1;
        const maybeOrigIndex = maybeOrigIndex_1;
        const maybeLemmaIndex_2 = maybeLemmaIndex_3;
        const maybePhonIndex = maybePhonIndex_1;
        const ortIndex = ortIndex_1 | 0;
        let patternInput;
        const groupValues = toList_1(map_3((group) => (group || ""), match(/^<who_name\s+(\S*?)>(?:<who_messageid\s+(\S+?)>)?:\s+(.*)\{\{(.+?)\}\}(.*?)$/g, head(searchResult_1.Text))));
        const sId = item(1, groupValues);
        const messageId = item(2, groupValues);
        let pre;
        const input = item(3, groupValues);
        pre = StringUtils_replace(`^<who_name\\s+${sId}>`, "", input);
        patternInput = [sId, messageId, pre, (m_1 = item(4, groupValues), isNullOrWhiteSpace(pre) ? replace(m_1, `^<who_name\\s+${sId}>`, "") : m_1), item(5, groupValues)];
        const searchWord_1 = patternInput[3];
        const sId_1 = patternInput[0];
        const pre_1 = patternInput[2];
        const post_1 = patternInput[4];
        const ortPre = processField(ortIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, pre_1);
        const ortMatch = processField(ortIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, searchWord_1);
        const ortPost = processField(ortIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, post_1);
        const ortText = StringUtils_replace("\\s*#", "", join(" ", concat([map((tuple_1) => tuple_1[1], ortPre), map((tuple_2) => tuple_2[1], ortMatch), map((tuple_3) => tuple_3[1], ortPost)])));
        let orthographic;
        const rowIndex_1 = rowIndex_5 | 0;
        const resultInfo_1 = new SearchResultInfo(searchResult_1.AudioType, searchResult_1.HasVideo, sId_1, patternInput[1], map((tuple_4) => tuple_4[0], ortPre), map((tuple_5) => tuple_5[0], ortMatch), map((tuple_6) => tuple_6[0], ortPost), ortText);
        const corpus_1 = corpus;
        const hasPhon = SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus_1), "phon");
        const resultLineFields = new ResultLineFields(resultInfo_1.SId, resultInfo_1.PreMatch, resultInfo_1.Match, resultInfo_1.PostMatch);
        const idCol = idColumn(corpus_1, model, resultInfo_1.SId, resultInfo_1.MessageId, resultInfo_1.FullText, rowIndex_1, loadedCorpusDispatch, dispatch);
        orthographic = createElement("tr", createObj(ofArray([["key", `ort${rowIndex_1}`], (elems_7 = toList_1(delay(() => {
            let elems_6;
            return append(singleton_1(createElement("td", createObj(ofArray([["style", {
                textAlign: "center",
                verticalAlign: "middle",
            }], (elems_6 = toList_1(delay(() => append(singleton_1(idCol), delay(() => ((!hasPhon) ? singleton_1(createElement("div", {
                style: {
                    marginTop: 5,
                },
                children: audioVideoLinks(resultInfo_1, rowIndex_1),
            })) : empty_1()))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => textColumns(resultLineFields)));
        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
        let phonetic;
        if (maybePhonIndex == null) {
            phonetic = (void 0);
        }
        else {
            const phonIndex = maybePhonIndex | 0;
            const phonPre = processField(phonIndex, ortIndex, maybeLemmaIndex_2, phonTipIndexes, pre_1);
            const phonMatch = processField(phonIndex, ortIndex, maybeLemmaIndex_2, phonTipIndexes, searchWord_1);
            const phonPost = processField(phonIndex, ortIndex, maybeLemmaIndex_2, phonTipIndexes, post_1);
            const phonText = StringUtils_replace("\\s*#", "", join(" ", concat([map((tuple_7) => tuple_7[1], phonPre), map((tuple_8) => tuple_8[1], phonMatch), map((tuple_9) => tuple_9[1], phonPost)])));
            phonetic = ((rowIndex_3 = (rowIndex_5 | 0), (resultInfo_2 = (new SearchResultInfo(searchResult_1.AudioType, searchResult_1.HasVideo, sId_1, "", map((tuple_10) => tuple_10[0], phonPre), map((tuple_11) => tuple_11[0], phonMatch), map((tuple_12) => tuple_12[0], phonPost), phonText)), (resultLineFields_1 = (new ResultLineFields(resultInfo_2.SId, resultInfo_2.PreMatch, resultInfo_2.Match, resultInfo_2.PostMatch)), createElement("tr", createObj(ofArray([["key", `phon${rowIndex_3}`], (elems_10 = toList_1(delay(() => {
                let elems_9;
                return append(singleton_1(createElement("td", createObj(ofArray([["style", {
                    textAlign: "center",
                    verticalAlign: "middle",
                }], (elems_9 = [audioVideoLinks(resultInfo_2, rowIndex_3)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => textColumns(resultLineFields_1)));
            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])))))));
        }
        let orig;
        if (maybeOrigIndex == null) {
            orig = (void 0);
        }
        else {
            const origIndex = maybeOrigIndex | 0;
            const origPre = processField(origIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, pre_1);
            const origMatch = processField(origIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, searchWord_1);
            const origPost = processField(origIndex, maybePhonIndex, maybeLemmaIndex_2, ortTipIndexes, post_1);
            orig = ((resultLineFields_2 = (new ResultLineFields(sId_1, map((tuple_13) => tuple_13[0], origPre), map((tuple_14) => tuple_14[0], origMatch), map((tuple_15) => tuple_15[0], origPost))), createElement("tr", createObj(ofArray([["key", `orig${rowIndex_5}`], (elems_11 = toList_1(delay(() => append(singleton_1(createElement("td", {
                style: {
                    verticalAlign: "middle",
                },
            })), delay(() => textColumns(resultLineFields_2))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])])))));
        }
        const separator = separatorRow(rowIndex_5);
        return toList_1(delay(() => append(singleton_1(orthographic), delay(() => {
            let matchValue_2, translation, children_4, children_2, elems_8, children_8, children_6;
            return append(singleton_1((matchValue_2 = FSharpMap__TryFind(model.Translations, `${model.ResultPageNo}_${rowIndex_5}`), (matchValue_2 == null) ? null : ((translation = matchValue_2, contains(new ExternalTool(0), Corpus__get_SharedInfo(corpus).ExternalTools, {
                Equals: equals,
                GetHashCode: safeHash,
            }) ? ((children_4 = ofArray([(children_2 = singleton(createElement("a", createObj(ofArray([["href", "http://translate.google.com/"], ["target", "_blank"], (elems_8 = [createElement("img", {
                src: "attr1-2.png",
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])))), createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            })), createElement("td", {
                colSpan: 3,
                style: {
                    color: "#737373",
                },
                dangerouslySetInnerHTML: {
                    __html: translation,
                },
            })]), createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            }))) : ((children_8 = ofArray([(children_6 = ofArray([createElement("span", {
                children: ["Translated by "],
            }), createElement("a", {
                href: "http://gtweb.uit.no/jorgal/index.nob.html?dir=sme-nob#",
                target: "_blank",
                children: "Giellatekno Apertium",
            })]), createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_6)),
            })), createElement("td", {
                colSpan: 3,
                style: {
                    color: "#737373",
                },
                children: JSON.parse('["' + translation + '"]')[0],
            })]), createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_8)),
            }))))))), delay(() => append((phonetic != null) ? singleton_1(value_155(phonetic)) : empty_1(), delay(() => append((orig != null) ? singleton_1(value_155(orig)) : empty_1(), delay(() => {
                let rowIndex_4, model_1, key_87, tokens_1, nodes, isMatch, elems_14;
                return append(Corpus__get_SharedInfo(corpus).IsTreebank ? singleton_1((rowIndex_4 = (rowIndex_5 | 0), (model_1 = model, (key_87 = (`${model_1.ResultPageNo}_${rowIndex_4}`), FSharpSet__Contains(model_1.VisibleSyntaxTreeKeys, key_87) ? ((tokens_1 = skip(3, split(StringUtils_replace("\\s*\u003c/who_name\u003e", " $\u0026", StringUtils_replace("\u003cwho_name\\s+(.+?)\u003e\\s*", "\u003cwho_name_$1\u003e ", item(0, FSharpMap__get_Item(model_1.ResultPages, model_1.ResultPageNo)[rowIndex_4].Text))), [])), (nodes = ((isMatch = false, toArray_2(delay(() => map_3((token_2) => {
                    if (isMatch_1(/^\{\{/g, token_2)) {
                        isMatch = true;
                    }
                    const attrs_1 = split(StringUtils_replace("\\}\\}$", "", StringUtils_replace("^\\{\\{", "", token_2)), ["/"], null, 0);
                    const orthographicForm = attrs_1[0];
                    const partOfSpeech = attrs_1[3];
                    const synFunc = attrs_1[attrs_1.length - 3];
                    const result_1 = new SyntaxNode(parse(attrs_1[attrs_1.length - 2], 511, false, 32), orthographicForm, partOfSpeech, parse(attrs_1[attrs_1.length - 1], 511, false, 32), synFunc, isMatch);
                    if (isMatch_1(/\}\}$/g, token_2)) {
                        isMatch = false;
                    }
                    return result_1;
                }, tokens_1))))), createElement("tr", createObj(ofArray([["key", `syntax_${key_87}`], (elems_14 = [createElement("td", {
                    colSpan: 4,
                    style: {
                        maxWidth: 1100,
                        overflowX: "auto",
                    },
                    children: createElement(syntax_tree, {
                        cnl: nodes,
                    }),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))])])))))) : null)))) : empty_1(), delay(() => singleton_1(separator)));
            }))))));
        }))));
    }, indexed_1(ofArray(pageResults)));
    const children_14 = ofArray([mediaPlayer, (props_38 = ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], ["className", "is-narrow"], ["className", "concordance-table"], (elems_15 = [createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(rows)),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_15))])]), createElement("table", createObj(Helpers_combineClasses("table", props_38))))]);
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_14)),
    });
}

